/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Crm_WebhookInputs */

const en_settings_crm_webhook = /** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universal CRM Webhook`)
};

const es_settings_crm_webhook = /** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook de CRM Universal`)
};

const fr_settings_crm_webhook = /** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook CRM universel`)
};

const de_settings_crm_webhook = /** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universeller CRM-Webhook`)
};

const id_settings_crm_webhook = /** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook CRM Universal`)
};

/** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */
const ja_settings_crm_webhook = en_settings_crm_webhook;

/** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */
const zh_settings_crm_webhook = en_settings_crm_webhook;

/** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */
const ar_settings_crm_webhook = en_settings_crm_webhook;

/** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */
const it_settings_crm_webhook = en_settings_crm_webhook;

/** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */
const ru_settings_crm_webhook = en_settings_crm_webhook;

/** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */
const pt_settings_crm_webhook = en_settings_crm_webhook;

/** @type {(inputs: Settings_Crm_WebhookInputs) => LocalizedString} */
const ko_settings_crm_webhook = en_settings_crm_webhook;

/**
* | output |
* | --- |
* | "Universal CRM Webhook" |
*
* @param {Settings_Crm_WebhookInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_crm_webhook = /** @type {((inputs?: Settings_Crm_WebhookInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Crm_WebhookInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_crm_webhook(inputs)
	if (locale === "es") return es_settings_crm_webhook(inputs)
	if (locale === "fr") return fr_settings_crm_webhook(inputs)
	if (locale === "de") return de_settings_crm_webhook(inputs)
	if (locale === "ja") return ja_settings_crm_webhook(inputs)
	if (locale === "zh") return zh_settings_crm_webhook(inputs)
	if (locale === "ar") return ar_settings_crm_webhook(inputs)
	if (locale === "id") return id_settings_crm_webhook(inputs)
	if (locale === "it") return it_settings_crm_webhook(inputs)
	if (locale === "ru") return ru_settings_crm_webhook(inputs)
	if (locale === "pt") return pt_settings_crm_webhook(inputs)
	return ko_settings_crm_webhook(inputs)
});